import { serviceColors } from "@/lib/apptDisplay";

export function ServiceColorRail({ appointment, className = "" }) {
  const colors = serviceColors(appointment);
  return (
    <span className={`stellar-service-rail ${className}`} aria-label={`${colors.length} Leistungscodes`}>
      {colors.map((color, index) => (
        <span key={`${color}-${index}`} style={{ backgroundColor: color }} />
      ))}
    </span>
  );
}

export function ServiceColorDots({ appointment, className = "" }) {
  const colors = serviceColors(appointment);
  return (
    <span className={`stellar-service-dots ${className}`} aria-label={`${colors.length} Leistungscodes`}>
      {colors.map((color, index) => (
        <span key={`${color}-${index}`} style={{ backgroundColor: color }} />
      ))}
    </span>
  );
}

export function ServiceColorTrack({ appointment, className = "" }) {
  const colors = serviceColors(appointment);
  return (
    <span className={`stellar-service-track ${className}`} aria-label={`${colors.length} Leistungscodes`}>
      {colors.map((color, index) => (
        <span key={`${color}-${index}`} style={{ backgroundColor: color }} />
      ))}
    </span>
  );
}
